<template>
  <!-- 4.多媒体展示案例 -->
  <div class="wrap_video wow fadeInUp">
    <el-row>
      <el-col :span="2" class="header_block"></el-col>
      <el-col :span="20" class="header_block" style="background:#fff">
        <!-- <div class="video_tv">VIDEO</div>
        <div class="video_text">宣传视频</div>-->
        <div class="shooting_one" ref="shooting_one" @click="selectPics(itemInit)">
          <img ref="shooting_img" :src="require('@/assets/imgs/video08.jpeg')" class="shoot_img" />
        </div>
        <div v-for="(item,index) in shootingArray" :key="index" :class="item.cName" @click="selectPics(item)">
          <img ref="shooting_img" :src="item.url" class="shoot_img" />
        </div>
      </el-col>
      <el-col :span="2" class="header_block"></el-col>
    </el-row>

    <el-row>
      <el-col :span="2" class="header_block"></el-col>
      <el-col :span="20" class="header_block" style="background:#fff">
        <div
          v-for="(item,index) in shootingArray1"
          :key="index"
          :class="item.cName"
          @click="selectPics(item)"
        >
          <img ref="shooting_img" :src="item.url" class="shoot_img" />
        </div>
      </el-col>
      <el-col :span="2" class="header_block"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'swiperCard3',
  data() {
    return {
      itemInit : {url:require('@/assets/video/video608.jpg'),text:'徐州未来智慧城市网络沙盘',videoUrl:require('@/assets/video/video608.mp4'),cName:'shooting_six mt10'},
      shootingArray:[ 
        // {url:require('@/assets/imgs/shooting01.jpeg'),cName:'shooting_one'},
        {url:require('@/assets/video/video601.jpg'),text:'箭牌Arrow发布会',videoUrl:require('@/assets/video/video601.mp4'),cName:'shooting_two mt10'},
        {url:require('@/assets/video/video602.jpg'),text:'产城之梦四折幕三维',videoUrl:require('@/assets/video/video602.mp4'),cName:'shooting_three mt10'},
        {url:require('@/assets/video/video603.jpg'),text:'中国电信裸眼3D',videoUrl:require('@/assets/video/video603.mp4'),cName:'shooting_three'},
        {url:require('@/assets/video/video604.jpg'),text:'国家地震局球幕专题片',videoUrl:require('@/assets/video/video604.mp4'),cName:'shooting_two'}
        // {url:require('@/assets/imgs/shooting06.jpeg'),cName:'shooting_one'},
        // {url:require('@/assets/imgs/shooting07.jpeg'),cName:'shooting_one'},
        // {url:require('@/assets/imgs/shooting08.jpeg'),cName:'shooting_two'},
        // {url:require('@/assets/imgs/shooting09.jpeg'),cName:'shooting_three'},
        // {url:require('@/assets/imgs/shooting10.jpeg'),cName:'shooting_three'},
        // {url:require('@/assets/imgs/shooting11.jpeg'),cName:'shooting_two'},
        // {url:require('@/assets/imgs/shooting12.jpeg'),cName:'shooting_one'},
        // {url:require('@/assets/imgs/shooting13.jpeg'),cName:'shooting_one'},
        // {url:require('@/assets/imgs/shooting14.jpeg'),cName:'shooting_two'},
        // {url:require('@/assets/imgs/shooting15.jpeg'),cName:'shooting_three'},
        // {url:require('@/assets/imgs/shooting16.jpeg'),cName:'shooting_three'},
        // {url:require('@/assets/imgs/shooting17.jpeg'),cName:'shooting_two'},
        // {url:require('@/assets/imgs/shooting18.jpeg'),cName:'shooting_one'},
      ],
       shootingArray1:[
        // {url:require('@/assets/imgs/shooting01.jpeg'),cName:'shooting_one'},
        {url:require('@/assets/video/video605.jpg'),text:'惠普暗影精灵笔记本发布会异形屏',videoUrl:require('@/assets/video/video605.mp4'),cName:'shooting_four mt10 mr10'},
        {url:require('@/assets/video/video606.jpg'),text:'北京世界公园大战外星人夜游投影',videoUrl:require('@/assets/video/video606.mp4'),cName:'shooting_five mt10 mr10'},
        {url:require('@/assets/video/video607.jpg'),text:'浙江密赛山崖激光秀',videoUrl:require('@/assets/video/video607.mp4'),cName:'shooting_six mt10'}
        // {url:require('@/assets/video/video608.jpg'),text:'徐州未来智慧城市网络沙盘',videoUrl:require('@/assets/video/video608.mp4'),cName:'shooting_six mt10'},
        ]
    }
  },

  mounted(){
    this.$nextTick(() => {
      new this.$wow.WOW({
        live:true
      }).init()
    })
    setTimeout(()=>{
    let initHeight = this.$refs.shooting_one.clientHeight
      console.log(initHeight,'1111')
      console.log(this.$refs.shooting_img,'9090')
      for (let i=0;i<this.$refs.shooting_img.length;i++) {
        this.$refs.shooting_img[i].style.height = (initHeight - 10)/2 + 'px'

      }
    },2000)
  },
  methods: {
    selectPics(item){
      console.log(item,'111')

      this.$emit('selectPics',item)
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_video {
  .header_block {
    min-height: 10px;
  }
  .shooting_one {
    width: calc((100% - 20px) * 0.55);
    // height: 46vh;
    // margin: 10px 0 0 10px;
    float: left;
    overflow: hidden;
  }
  .shooting_two {
    width: calc((100% - 20px) * 0.25);
    margin: 0px 0 0 10px;
    float: left;
    // height: 23vh;
    overflow: hidden;
  }
  .shooting_three {
    width: calc((100% - 20px) * 0.2);
    margin: 0px 0 0 10px;
    float: left;
    // height: 23vh;
    overflow: hidden;
  }
  .shooting_four {
    width: calc((100% - 20px) * 0.45);
    float: left;
    overflow: hidden;
  }
  .shooting_five {
    width: calc((100% - 20px) * 0.35);
    float: left;
    overflow: hidden;
  }
  .shooting_six {
    width: calc((100% - 20px) * 0.2);
    float: left;
    overflow: hidden;
  }
  .mt10 {
    margin-bottom: 10px;
  }
  .mr10 {
    margin-right: 10px;
  }
  .shoot_img {
    width: 100%;
    height: 100%;
  }
}
</style>



